import { useEffect, useState } from 'react'
import { flushSync } from 'react-dom'

/**
 * "Printed Wed, Sep 23, 10:12 AM" for a print document that stays mounted.
 *
 * The chef pages keep their packet ambiently mounted (so a system print has
 * something to snapshot), which means it rendered whenever the page did, not
 * when it printed. `beforeprint` refreshes the time, and `flushSync` commits
 * it before the browser reads the page; a plain state update would land after
 * the snapshot and print the stale time.
 */
export function usePrintedAt(): Date {
  const [printedAt, setPrintedAt] = useState(() => new Date())
  useEffect(() => {
    const refresh = () => flushSync(() => setPrintedAt(new Date()))
    window.addEventListener('beforeprint', refresh)
    return () => window.removeEventListener('beforeprint', refresh)
  }, [])
  return printedAt
}
